export async function safeRequest(promise) {
  try {
    const data = await promise;
    return { status: 200, data, message: null };
  } catch (error) {
    let errorData = error?.response?.data;

    if (errorData instanceof Blob) {
      try {
        const text = await errorData.text();

        if (errorData.type === "application/json") {
          errorData = JSON.parse(text);
        } else {
          errorData = text;
        }
      } catch (e) {
        console.warn("Erro ao converter Blob:", e);
      }
    }

    return {
      status: error?.response?.status || 500,
      data: errorData || null,
      message:
        errorData?.msg ||
        errorData?.message ||
        error?.message ||
        "Erro desconhecido",
    };
  }
}
